import { Component, OnInit, Input } from '@angular/core';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { Scene } from 'src/app/models/Scene';
import { AssetEvent } from 'src/app/models/vr-events/AssetEvent';
import { VrEventService } from 'src/app/services/vr-event.service';
import { VrEventTypeService } from 'src/app/services/vr-event-type.service';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { VrEventTriggerService } from 'src/app/services/vr-event-trigger.service';
import { VrEvent } from 'src/app/models/vr-events/VrEvent';
import { toTypeScript } from '@angular/compiler';

@Component({
  selector: 'app-asset-events-input',
  templateUrl: './asset-events-input.component.html',
  styleUrls: ['./asset-events-input.component.scss'],
})
export class AssetEventsInputComponent implements OnInit {


  constructor(
    public VrEventService: VrEventService,
    public VrEventTypeService: VrEventTypeService,
    public assetTypeService: AssetTypeService,
    public VrEventTriggerService: VrEventTriggerService) { }

  ngOnInit() {
  }

  getNumberOfEvents() {
    return this.VrEventService.getNumberOfEvents();
  }

  getActiveAssetEvents() {
    return this.VrEventService.getActiveAssetEvents();
  }

  getActiveAssetsInScene() {
    return this.VrEventService.getActiveAssetsInScene();
  }

  getEventTypes() {
    return this.VrEventTypeService.types;
  }

  getEventType(eventTypeId) {
    return this.VrEventTypeService.getType(eventTypeId);
  }

  isObjectEventType(eventTypeId: number) {
    return this.VrEventService.isObjectEventType(eventTypeId);
  }

  isMediaEventType(eventTypeId: number) {
    return this.VrEventService.isMediaEventType(eventTypeId);
  }

  isAssetVideoOrAudio(assetTypeId) {
    return this.VrEventService.isAssetVideoOrAudio(assetTypeId);
  }

  getAssetType(assetTypeId) {
    return this.assetTypeService.getType(assetTypeId);
  }

  selectNewAssetPosition(eventIndex) {
    // VrEventService.selectNewAssetPosition(assetInScene, eventIndex);
  }

  removeEvent(assetEvent: AssetEvent) {
    this.VrEventService.removeEvent(assetEvent, this.VrEventService.assetInScene);
  }

  addEvent() {
    this.VrEventService.addEvent();
  }

  getScenes() {
    return this.VrEventService.scenes;
  }

  setSelected(assetEvent) {
    if (this.VrEventService.scenes.length > 0) {
      if (assetEvent.linkedContentId == -1) {
        this.setDefaultScene(assetEvent);
      }
      else if (this.VrEventService.scenes.filter(x => x.sceneId == assetEvent.linkedContentId && x.active).length == 0) {
        this.setDefaultScene(assetEvent);
      }
    }
    return true;
  }

  setDefaultScene(assetEvent) {
    var scenes = this.VrEventService.scenes.filter(x => x.active == true);
    if (scenes.length > 0) {
      assetEvent.linkedContentId = scenes[0].sceneId;
    }
    else {
      assetEvent.eventTypeId = 0;
    }
  }
}
